<div class="nt9-popup-content">
  <h2>Attenzione!</h2>
  <p>
    Se l'utente appena creato è un operatore aziendale, ricordati di inserirlo anche sul <b>SISTEMA NT9</b>.
  </p>
  <div style="text-align: center;">
    <p-button icon="pi pi-check" (onClick)="close()" label="CHIUDI" class="p-button-text mr-1"
      styleClass="p-button-success"></p-button>
  </div>
</div> 